import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getMyPoints = () => httpClient.get(apis.GET_MY_POINTS);
export const getPointsGoodsList = () => httpClient.get(apis.GET_POINTS_GOODS_LIST);
export const makePointsYzQrcode = payload =>
  httpClient.post(apis.MAKE_POINTS_YZ_QRCODE, { ...payload }, { ignore: true });
export const getPointsYzStatus = qrid => httpClient.get(apis.GET_POINTS_YZ_STATUS + qrid + '/2');
export const getPointsYzStatusOnce = qrid =>
  httpClient.get(apis.GET_POINTS_YZ_STATUS + qrid + '/2');
export const makePointsPaypalUrl = payload =>
  httpClient.post(apis.MAKE_POINTS_PAYPAL_URL, { ...payload }, { ignore: true });
export const getPointsPaypalInfo = payload =>
  httpClient.get(apis.GET_POINTS_PAYPAL_INFO + payload.token + '/' + payload.PayerID);
export const getPointsPaypalResult = payload =>
  httpClient.get(apis.GET_POINTS_PAYPAL_RESULT + payload.token);
